










  import { Component, Vue, Provide } from 'vue-property-decorator';
  import newOrder from "./components/newOrder.vue";
  import { ticketClient } from "@/api/index";
import {
  GetTicketListParamReq,
} from "@/pbjs/external/ticket/ticket_pb";
import { setCommon, handleResponse, errorMsg } from "@/utils/request";

  @Component({
    name: 'orderDeal',
    components: { newOrder }
  })

  export default class CombinationProperty extends Vue {
    @Provide() private activeName:string = "wait";
    @Provide() private phoneSaleItemList: Array<Object> = []; // 增加电销结果选择列表

    private handleClick(tab:any, event:any) {
        // 点击tab,缓存
        localStorage.setItem('handleTab', tab.name);
    };

    private created() {
        // 刷新页面获取缓存或者默认值
        this.activeName = localStorage.getItem('handleTab') || 'wait'; 
        this.getTicketListParam();
    }

      // 查询需要的select下拉框
  private getTicketListParamFuc(data: any) {
    this.phoneSaleItemList = data.phonesaleitemList;
  }
  private getTicketListParam() {
    let request: any = new GetTicketListParamReq();
    request.setCommonin(setCommon());
    ticketClient.getPsTicketListParam(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        let _fuc = this.getTicketListParamFuc;
        handleResponse(data, _fuc);
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

    private destroyed() {
        // 页面销毁时,将缓存修改为默认值，以便第一次进入时查看默认选中tab
        localStorage.setItem('handleTab', 'wait');
    }
  }
